import { useEffect, useState } from "react";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";

import Search from "../../../../components/DstIcons/Search";
import Lister from "../../../../components/Lister/Lister";
import { formatDateHumanly } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { fetchUserDocuments, openDocument } from "./UserDocuments.function";

const UserDocuments = ({ userId, language }: { userId: number; language: string }): JSX.Element => {
  const [documents, setDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserDocuments(userId, setDocuments, setLoading);
  }, [userId]);

  return (
    <Container fluid>
      {!loading ? (
        <Lister
          items={documents.map((user_document: any) => ({
            ...user_document,
            date: user_document.dt_updated || user_document.dt_created,
          }))}
          columns={[
            { header: translate(language, "PAGES.USER.DOCUMENT_TABLE.NAME"), key: "name" },
            {
              header: translate(language, "PAGES.USER.DOCUMENT_TABLE.DATE"),
              key: "date",
              render: (item: any) => (
                <div>
                  <OverlayTrigger overlay={<Tooltip>{formatDateHumanly(language, item["date"], true)}</Tooltip>}>
                    <span>{formatDateHumanly(language, item["date"])}</span>
                  </OverlayTrigger>
                </div>
              ),
            },
          ]}
          additionalButton={(item: any) => (
            <span className="clickable" onClick={() => openDocument(item.type, item.filename)}>
              <Search classes="search-icon" />
            </span>
          )}
        />
      ) : (
        <Lister
          columns={[
            { header: translate(language, "PAGES.USER.DOCUMENT_TABLE.NAME"), key: "name" },
            { header: translate(language, "PAGES.USER.DOCUMENT_TABLE.DATE"), key: "date" },
          ]}
          mock
        />
      )}
    </Container>
  );
};

export default UserDocuments;
